import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Home.css'


import MyNavbar from '../CommonComponents/Navbar'
import MyFooter from '../CommonComponents/Footer'


import Counters from '../LandingPageComponents/Counters'
import IntroContainer from '../LandingPageComponents/IntroContainer'
import DataVisualizationFeature from '../LandingPageComponents/DataVisualizationFeature'
import ReportGenerationFeature from '../LandingPageComponents/ReportGenerationFeature'
import FeatureVideoComponent from '../LandingPageComponents/ResponsiveFeatureVideoComponent'

export default class home extends Component {
        render() {
                return (
                        <div id="main-home-page" >
                                <MyNavbar backgroundColor="white"/>
                                <div id="main-home-container">
                                        <IntroContainer/>
                                        <Counters />
                                        <DataVisualizationFeature/>
                                        <div id="parallax1">
                                                <div id="parallax1-inner">
                                                        <h3>START RIGHT NOW </h3>
                                                        <p>Get yourself registered here</p>
                                                        <a href="/auth" className="btn btn-primary mt-2">Sign Up</a>
                                                </div>
                                        </div>
                                        <ReportGenerationFeature/>
                                        <div id="parallax2">
                                                <div id="parallax2-inner">
                                                        <h1 >Scalable Dashboards<br></br></h1>
                                                        <p style={{ fontSize: "20px" }}>You will get the fully functional and responsive dashboard to perform<br></br> Exploratory Data Analysis on your data</p>
                                                </div>
                                        </div>
                                        <FeatureVideoComponent/>
                                </div>
                                <MyFooter/>
                        </div>
                )
        }
}
